import { PropsWithChildren } from 'react';

function OniNotFound({ children }: PropsWithChildren<{}>) {
    return <div className="catalog-content catalog-content--list">{children}</div>;
}

export default OniNotFound;
